import { BookOpen } from 'lucide-react';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useBetting } from '../../../../../../../Context/BettingContext';
import { sendNotfication } from '../../../../../../../Helper';

const Container = styled.div`
  width: 100%;
  font-family: 'Montserrat Alternates', sans-serif;
  background: #292d2e;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: rgb(50, 55, 56);
  color: white;
  font-family: 'Montserrat Alternates', sans-serif;
`;

const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  font-weight: bold;
  font-size: 10px;
  font-family: 'Montserrat Alternates', sans-serif;
`;

const MatchedInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 10px;
  font-family: 'Montserrat Alternates', sans-serif;
`;

const InfoIcon = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #6E6E6E;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;

const ChartIcon = styled.span`
  color: #6E6E6E;
`;

const Table = styled.div`
  width: 100%;
`;

const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  border-bottom: 1px solid rgb(50, 55, 56);
  // background: rgb(50, 55, 56);
  font-family: 'Montserrat Alternates', sans-serif;
`;

const HeaderCell = styled.div`
  width: 90px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  font-weight: bold;
  color: white;
  border-left: 1px solid rgb(50, 55, 56);
  font-family: 'Montserrat Alternates', sans-serif;

  &:first-child {
    width: auto;
    border-left: none;
  }
`;

const TableRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  border-bottom: 1px solid rgb(50, 55, 56);
  background: ${props => (props.highlight ? '#292d2e' : '#292d2e')};
  position: relative;
  font-family: 'Montserrat Alternates', sans-serif;
`;

const TeamCell = styled.div`
  padding: 12px;
  font-size: 11px;
  color: white;
  display: flex;
  align-items: center;
  font-family: 'Montserrat Alternates', sans-serif;
`;

const OddsCell = styled.div`
  width: 90px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${props => (props.type === 'back' ? '#72BBEF' : '#FFB6C1')};
  border-left: 1px solid rgb(50, 55, 56);
  cursor: pointer;
  font-family: 'Montserrat Alternates', sans-serif;

  .odds {
    font-weight: bold;
    font-size: 10px;
    color: black;
  }

  .volume {
    font-size: 8px;
    color: black;
  }
`;

// New styled components for bet container
const BetContainer = styled.div`
  padding: 12px;
  background: #292d2e;
  border-top: 1px solid rgb(50, 55, 56);
  color: white;
  font-family: 'Montserrat Alternates', sans-serif;
`;

const BetInputContainer = styled.div`
  display: flex;
  align-items: stretch;
  height: 40px;
  border: 1px solid rgb(50, 55, 56);
  border-radius: 4px;
  overflow: hidden;
  background: #292d2e;
  font-family: 'Montserrat Alternates', sans-serif;
  margin-bottom: 12px;
`;

const AdjustButton = styled.div`
  width: 40px;
  border: none;
  background: rgb(50, 55, 56);
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Montserrat Alternates', sans-serif;

  &:hover {
    background: rgb(60, 65, 66);
  }

  &:active {
    background: rgb(40, 45, 46);
  }
`;

const BetInput = styled.div`
  flex: 1;
  padding: 6px;
  font-size: 16px;
  text-align: center;
  background: #292d2e;
  color: white;
  display: flex;
  min-width: 100px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(50, 55, 56);
  font-family: 'Montserrat Alternates', sans-serif;
`;

const QuickAmounts = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 2px;
  margin-bottom: 8px;
`;

const QuickAmount = styled.div`
  padding: 4px;
  text-align: center;
  background: #292d2e;
  border: 1px solid rgb(50, 55, 56);
  cursor: pointer;
  color: white;
  font-size: 10px;
  font-family: 'Montserrat Alternates', sans-serif;

  &:hover {
    background: rgb(50, 55, 56);
  }
`;

const NumberPad = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 2px;
  width: 100%;
`;

const NumberButton = styled.div`
  padding: 12px;
  text-align: center;
  background: #292d2e;
  border: 1px solid rgb(50, 55, 56);
  cursor: pointer;
  color: white;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Montserrat Alternates', sans-serif;

  &:hover {
    background: rgb(50, 55, 56);
  }
`;

const CrossButton = styled(NumberButton)`
  font-weight: bold;
  font-size: 16px;
`;

const ActionButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  margin-top: 8px;
`;

const CancelButton = styled.div`
  padding: 10px;
  text-align: center;
  background: #292d2e;
  border: 1px solid rgb(50, 55, 56);
  cursor: pointer;
  color: white;
  font-size: 12px;
  font-family: 'Montserrat Alternates', sans-serif;
`;

const PlaceButton = styled.div`
  padding: 10px;
  text-align: center;
  background: rgb(240, 156, 6);
  border: 1px solid rgb(240, 156, 6);
  cursor: pointer;
  color: black;
  font-size: 12px;
  font-weight: bold;
  font-family: 'Montserrat Alternates', sans-serif;
`;

const AcceptOddsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
  gap: 5px;
  color: white;
  font-size: 10px;
  font-family: 'Montserrat Alternates', sans-serif;
`;

const AcceptOddsCheckbox = styled.input`
  margin: 0;
  cursor: pointer;
`;

const StatusBar = styled.div`
  background: rgb(50, 55, 56);
  color: white;
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 10px;
  font-family: 'Montserrat Alternates', sans-serif;
`;
const BookmakerTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Montserrat Alternates', sans-serif;
`;

// Rename SuspendedOverlay to StatusOverlay
const StatusOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 56.33%;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(200, 200, 200, 0.85),
    rgba(180, 180, 180, 0.9)
  );
  box-shadow:
    inset 0 0 20px rgba(160, 160, 160, 0.4),
    inset 0 0 40px rgba(140, 140, 140, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  backdrop-filter: blur(1px);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(80, 80, 80, 0.15);
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      45deg,
      rgba(120, 120, 120, 0.1),
      rgba(100, 100, 100, 0.2)
    );
    z-index: -2;
  }
`;
const BetInputc = styled.input`
  width: 60px;
  text-align: center;
  font-size: 14px;
  padding: 4px;
   border: 1px solid rgb(50, 55, 56);
  border-radius: 4px;
  color: white;
    background: #292d2e;
     font-family: 'Montserrat Alternates', sans-serif;
`;

const StatusText = styled.span`
  color: white;
  font-weight: 600;
  font-size: 14px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
`;

// Create a container for OddsCell with relative positioning
const OddsCellContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const BookeMakerMobileMarket = ({ matchData, bookmakerData }) => {
  const [selectedBets, setSelectedBets] = useState({});
  const [betAmounts, setBetAmounts] = useState({});
  const [acceptAnyOdds, setAcceptAnyOdds] = useState({});
  const { placeBets } = useBetting();

  // per-slip placement locks to prevent duplicate taps
  const [placingKeys, setPlacingKeys] = useState({});

  // NOTE: now accepts selectionStatus as the 5th arg
  const handleOddsClick = (selectionId, team, type, odds, selectionStatus) => {
    // Prevent selecting if suspended
    if (selectionStatus === 'SUSPEND') {
      sendNotfication('This market is suspended. You cannot place bets on suspended selections.', 'error', 'bottom-left');
      return;
    }

    const betKey = `${selectionId}-${type}`;
    const oppositeType = type === 'back' ? 'lay' : 'back';
    const oppositeKey = `${selectionId}-${oppositeType}`;

    setSelectedBets(prev => {
      const newBets = { ...prev };

      if (newBets[betKey]) {
        delete newBets[betKey]; // toggle off
      } else {
        delete newBets[oppositeKey]; // remove opposite
        // store selectionStatus with the bet so we can guard on placement too
        newBets[betKey] = { team, type, odds, selectionId, selectionStatus };
      }
      return newBets;
    });

    if (!betAmounts[betKey]) {
      setBetAmounts(prev => ({
        ...prev,
        [betKey]: '100'
      }));
    }
  };

  const handleAmountChange = (betKey, amount) => {
    setBetAmounts(prev => ({ ...prev, [betKey]: amount.toString() }));
  };

  const handleNumberClick = (betKey, num) => {
    setBetAmounts(prev => {
      const currentAmount = prev[betKey] || '0';
      if (currentAmount === '100' && num !== '00') {
        return { ...prev, [betKey]: num.toString() };
      } else {
        return { ...prev, [betKey]: currentAmount + num.toString() };
      }
    });
  };

  const handleClear = (betKey) => {
    setBetAmounts(prev => ({ ...prev, [betKey]: '0' }));
  };

  const adjustBetAmount = (betKey, adjustment) => {
    setBetAmounts(prev => {
      const currentAmount = Number(prev[betKey] || 0);
      const newAmount = Math.max(0, currentAmount + adjustment);
      return { ...prev, [betKey]: newAmount.toString() };
    });
  };

  const handleCancelBet = (betKey) => {
    setSelectedBets(prev => {
      const newBets = { ...prev };
      delete newBets[betKey];
      return newBets;
    });
  };

  const quickAmounts = [100, 1000, 2000, 5000, 50000, 100000];

  const renderBetContainer = (betKey, bet) => {
    const isPlacing = Boolean(placingKeys[betKey]);

    return (
      <BetContainer key={betKey} betType={bet.type}>
        <div style={{ fontSize: '12px', color: 'white', textAlign: 'right', margin: "1px 6px 1px 0px", fontFamily: 'normal' }}>Min Bet</div>
        <div style={{ display: 'flex', gap: '10px', margin: '0px 0px 0px 0px', alignItems: 'center' }}>
          <div style={{ marginTop: '-10px', flex: 1 }}>
            <BetInput>{bet.odds}</BetInput>
          </div>
          <BetInputContainer>
            <AdjustButton onClick={() => adjustBetAmount(betKey, -10)}>-</AdjustButton>
            <BetInput>{betAmounts[betKey]}</BetInput>
            <AdjustButton onClick={() => adjustBetAmount(betKey, 10)}>+</AdjustButton>
          </BetInputContainer>
        </div>

        <QuickAmounts>
          {quickAmounts.map(amount => (
            <QuickAmount
              key={amount}
              onClick={() => handleAmountChange(betKey, amount)}
            >
              {amount}
            </QuickAmount>
          ))}
        </QuickAmounts>

        <NumberPad>
          {[1, 2, 3, 4, 5, 6].map((num) => (
            <NumberButton key={num} onClick={() => handleNumberClick(betKey, num)}>
              {num}
            </NumberButton>
          ))}
          <CrossButton onClick={() => handleClear(betKey)}>×</CrossButton>
          {[7, 8, 9, 0, '00'].map((num) => (
            <NumberButton key={num} onClick={() => handleNumberClick(betKey, num)}>
              {num}
            </NumberButton>
          ))}
        </NumberPad>

        <ActionButtons>
          <CancelButton
            onClick={() => handleCancelBet(betKey)}
            style={{ opacity: isPlacing ? 0.6 : 1, pointerEvents: isPlacing ? 'none' : 'auto' }}
          >
            Cancel
          </CancelButton>
          <PlaceButton
            onClick={async () => {
              // prevent duplicate placement for this betKey
              if (placingKeys[betKey]) {
                console.warn('Placement already in progress for', betKey);
                return;
              }

              // EXTRA SAFETY: block placement if selection is suspended (status might have changed)
              if (bet.selectionStatus === 'SUSPEND') {
                sendNotfication('This market is suspended. Cannot place bet.', 'error', 'bottom-left');
                return;
              }

              // Check current odds against live bookmakerData to ensure odds didn't change
              const latestMarket = bookmakerData.find(m => String(m.selectionId) === String(bet.selectionId));
              if (!latestMarket) {
                sendNotfication('Market not found. Try again.', 'error', 'bottom-left');
                return;
              }

              const latestOdds = bet.type === 'back' ? latestMarket.backOdds : latestMarket.layOdds;
              const originalOdds = bet.odds;

              // Compare numerically to avoid string mismatches
              const latestOddsNum = parseFloat(latestOdds);
              const originalOddsNum = parseFloat(originalOdds);

              if (Number.isFinite(latestOddsNum) && Number.isFinite(originalOddsNum) && latestOddsNum !== originalOddsNum) {
                sendNotfication('Odds have changed. You cannot place a bet at the old odds.', 'error', 'bottom-left');
                // also deselect the bet so user can re-select if they want
                handleCancelBet(betKey);
                return;
              }

              const stake = parseFloat(betAmounts[betKey] || '0');
              const oddsNum = parseFloat(bet.odds || '0');
              if (!stake || stake < 4 || !oddsNum || oddsNum <= 1) {
                sendNotfication('Enter valid stake (>=4) and odds (>1).', 'error', 'bottom-left');
                return;
              }

              const betRow = {
                market: 'BM',
                matchId: matchData?.id,
                matchTitle: `${matchData.team1} v ${matchData.team2}`,
                selectionName: bet?.team,
                category: 'Bookmaker Market',
                type: bet?.type,
                odds: oddsNum,
                stake: stake,
                liability: bet.type === 'lay' ? stake * (oddsNum - 1) : stake,
                eventid: matchData.eventid,
                selectionId: bet.selectionId
              };

              // set lock
              setPlacingKeys(prev => ({ ...prev, [betKey]: true }));

              try {
                const result = await placeBets([betRow]);
                if (result?.confirmed?.length > 0) {
                  sendNotfication('Bets placed successfully!', 'success', 'bottom-left');
                  handleCancelBet(betKey);
                } else {
                  sendNotfication(result?.errors?.[0]?.message || 'Bet placement failed', 'error', 'bottom-left');
                }
              } catch (err) {
                console.error('Error placing bet:', err);
                sendNotfication('An unexpected error occurred while placing the bet.', 'error', 'bottom-left');
              } finally {
                // release lock
                setPlacingKeys(prev => {
                  const copy = { ...prev };
                  delete copy[betKey];
                  return copy;
                });
              }
            }}
            style={{ opacity: isPlacing ? 0.6 : 1, pointerEvents: isPlacing ? 'none' : 'auto' }}
          >
            {isPlacing ? 'Placing...' : 'Place Bet'}
          </PlaceButton>
        </ActionButtons>

        {/* <AcceptOddsContainer>
          <AcceptOddsCheckbox
            type="checkbox"
            checked={acceptAnyOdds[betKey] || false}
            onChange={() => setAcceptAnyOdds(prev => ({
              ...prev,
              [betKey]: !prev[betKey]
            }))}
          />
          <span>Accept any odds</span>
        </AcceptOddsContainer> */}
      </BetContainer>
    );
  };

  return (
    <>
      <StatusBar>
        <BookmakerTitle>
          <BookOpen size={16} />
          <div>Bookmaker Market</div>
        </BookmakerTitle>
        <div>Zero Commission</div>
      </StatusBar>

      <Table>
        <TableHeader>
          <HeaderCell></HeaderCell>
          <HeaderCell>Back</HeaderCell>
          <HeaderCell>Lay</HeaderCell>
        </TableHeader>

        {bookmakerData.map((market) => {
          const backKey = `${market.selectionId}-back`;
          const layKey = `${market.selectionId}-lay`;

          return (
            <React.Fragment key={market.selectionId}>
              <TableRow>
                <TeamCell>{market.selectionName}</TeamCell>

                <OddsCell
                  type="back"
                  onClick={() => handleOddsClick(market.selectionId, market.selectionName, 'back', market.backOdds, market.selectionStatus)}
                  selected={selectedBets[backKey]}
                >
                  <span className="odds">{market.backOdds}</span>
                </OddsCell>

                <OddsCell
                  type="lay"
                  onClick={() => handleOddsClick(market.selectionId, market.selectionName, 'lay', market.layOdds, market.selectionStatus)}
                  selected={selectedBets[layKey]}
                >
                  <span className="odds">{market.layOdds}</span>
                </OddsCell>

                {market.selectionStatus === "SUSPEND" && (
                  <StatusOverlay>
                    <StatusText>Suspended</StatusText>
                  </StatusOverlay>
                )}
              </TableRow>

              {Object.entries(selectedBets)
                // ensure we only render bets for this market
                .filter(([key]) => key.startsWith(String(market.selectionId)))
                .map(([betKey, bet]) => renderBetContainer(betKey, bet))}
            </React.Fragment>
          );
        })}
      </Table>
    </>
  );
};

export default BookeMakerMobileMarket;
